<template>
    <div class="tos">
        <modal
            name="tos"
            @before-open="fetchTos"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="60%"
            height="auto"
        >
            <div class="modal__content">
                <div class="tos" v-html="tosContent"></div>
                <div class="modal__footer">
                    <span class="btn btn--hollow btn--small" @click="rejectTos">En hyväksy</span>
                    <button class="btn btn--call-to-action btn--small" v-on:click.stop="acceptTos">
                        OK
                    </button>
                </div>

            </div>
        </modal>
        <div class="accept-terms">
            <div class="checkbox">
                <label class="inline" for="tosChecked">
                    <input class="inline" type="checkbox" id="tosChecked" name="tosChecked" v-model="accepted" @change="onChange">
                    Hyväksyn <a @click="openTos">tilausehdot</a><span v-if="hasContract"> sekä </span>
                    <a v-if="hasContract" :href="contractDownloadUrl">bändin sopimusehdot </a> ja sitoudun noudattamaan niitä
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import ApiCall from '../modules/ApiCall';
    import Routes from '../modules/Routes';

    export default {
        model: {
            prop: 'accepted',
            event: 'change'
        },
       props: {
          checksum: {
              type: String,
              required: true
          },
          id: {
              type: String,
              required: true,
          },
         hasContract: {
              type: Boolean,
              required: true
         }
       },
        data() {
            return {
                accepted: false,
                tosState: 'closed',
                tosContent: ''
            };
        },
        computed: {
            contractDownloadUrl() {
              return Routes.generate('_public_api_download_quote_contract', { hash: this.checksum, id: this.id });
            },
        },
        methods: {
            onChange() {
                if (this.tosState !== 'open') {
                    this.openTos();
                }
                this.$emit('change', this.accepted);
            },
            openTos() {
                this.tosState = 'open';
                this.$modal.show('tos');
            },
            acceptTos(e) {
                e.preventDefault();
                this.tosState = 'closed';
                this.$modal.hide('tos');
                this.accepted = true;
                return false;
            },
            rejectTos() {
                this.tosState = 'closed';
                this.$modal.hide('tos');
                this.accepted = false;
                return false;
            },
            fetchTos() {
                ApiCall.getCached('/fi/terms-and-conditions/book/fi/fi').then((html) => {
                    this.tosContent = html;
                });
            }
        },
    };
</script>
